import gsap from 'gsap'

export const fadeAnimation = (
  node: HTMLElement,
  active: boolean,
  done: () => void
) => {
  gsap.killTweensOf(node.children)

  if (active) {
    gsap.set(node, { opacity: 1 })
    gsap.set(node.children, { opacity: 0 })
  }

  gsap
    .timeline({
      defaults: {
        duration: active ? 1 : 0.6,
        ease: active ? 'power2.inOut' : 'power2.out'
      },
      onComplete: done
    })
    .to(node.children, { opacity: active ? 1 : 0 })
}
